import React from 'react';
import styled from 'styled-components/macro';
import { Typography } from '@deeptrue-frontend/ui';
import { getTranslation, LocaleType } from '../utils/getTranslations';
import { StatementType } from './types';

const Box = styled.div<{ isDontKnow?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 1.5rem;
  margin-top: ${({ isDontKnow }) => (isDontKnow ? '2.75rem' : 0)};
`;

const BarContainer = styled.div`
  width: 100%;
  border-radius: 5px;
  height: 0.5rem;
  background-color: #e3e5e8;
`;

const Fill = styled.div<{ width: number; isDontKnow?: boolean }>`
  height: 100%;
  min-width: 1px;
  background-color: ${({ isDontKnow }) => (isDontKnow ? '#8F96A3' : '#1656e9')};
  width: ${({ width }) => width}%;
  border-radius: 5px;
`;

const Title = styled.div`
  display: flex;
  margin-bottom: 0.25rem;
`;

interface Props extends StatementType {
  locale: LocaleType;
}

const Bar = ({ value, label, isDontKnow, has_none, locale }: Props) => {
  return (
    <Box isDontKnow={isDontKnow || has_none}>
      <Title>
        <Typography fontWeight="700" fontSize="0.875rem" mr="0.5rem">
          {value}%
        </Typography>
        <Typography fontWeight="400" fontSize="0.875rem">
          {getTranslation(label, locale)}
        </Typography>
      </Title>
      <BarContainer>
        <Fill width={value} isDontKnow={isDontKnow || has_none} />
      </BarContainer>
    </Box>
  );
};

export default Bar;
